module.exports = __webpack_public_path__ + "static/media/aplication4.d29d56e6.png";